import * as React from "react";
// import {TMessageSignature} from "../../../../type/common";
import styled from "styled-components";
import { Project } from "../../../../domain/model/project";
import Paragraph from "../../atom/text/paragraph";
import ParagraphSup from "../../atom/text/paragraph_sup";

import { MessageRoom } from "src/domain/model/message_room";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import { ConstBorderRound } from "../../../../config/styles_const/styles_const";
import AvatarSmall from "../../atom/avatar/avatar_small";
import BtnLinkBorderSmall from "../../atom/btn/btn_link_border_small";

interface IProps {
  project: Project | null;
  companyIcon?: string;
  companyName?: string;
  projectURL: string;
  contractURL: string;
  customerId: string;
  messageRoom: MessageRoom;
}

const MessageRoomProjectInfo: React.FC<IProps> = (props) => {
  const {
    project,
    companyIcon,
    companyName,
    projectURL,
    contractURL,
    customerId,
    messageRoom,
  } = props;

  if (!project || !companyIcon || !companyName) {
    return null;
  }

  return (
    <React.Fragment>
      {
        <Wrapper>
          <Inner>
            <Img src={project.getThumbnailURL()} />
          </Inner>
          <Inner>
            <CompanyWrapper>
              <Avatar src={companyIcon} />
              <Paragraph bold={true}>{companyName}</Paragraph>
            </CompanyWrapper>
          </Inner>
          <Inner>
            <Paragraph bold={true}>{project.name}</Paragraph>
          </Inner>
          <Inner>
            <ParagraphSup>{project.description}</ParagraphSup>
          </Inner>
          <ButtonWrapper>
            <DetailLink to={projectURL}>案件詳細</DetailLink>
            {!messageRoom.hasContract && (
              <DetailLink to={contractURL}>成約報告</DetailLink>
            )}
            {messageRoom.hasContract && (
              <ContractDisableLink>成約報告</ContractDisableLink>
            )}
          </ButtonWrapper>
        </Wrapper>
      }
    </React.Fragment>
  );
};

export default MessageRoomProjectInfo;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

const Inner = styled.div`
  margin-bottom: 10px;
`;

const CompanyWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Avatar = styled(AvatarSmall)`
  margin-right: 10px;
`;

const ButtonWrapper = styled(Inner)`
  display: flex;
  justify-content: center;
`;

const CustomBtnLinkBorderSmall = styled(BtnLinkBorderSmall)`
  padding: 0 50px;
  font-weight: 700;
`;

const Img = styled.img`
  width: 100%;
  height: 110px;
  border-radius: ${ConstBorderRound.CornerRoundAll};
  object-fit: cover;
`;

const DetailLink = styled(GoldLink)`
  margin: 0px 15px;
`;

const ContractDisableLink = styled.div`
  color: #a4a4a4;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  padding: 4px 20px;
  margin: 0px 15px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/message_room/message_room_project_info.tsx